import { render, staticRenderFns } from "./ClickoutAnchor.vue?vue&type=template&id=b693a770"
import script from "./ClickoutAnchor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClickoutAnchor.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports